import React, { useState } from "react";
import Select2V2 from "@components/FormsV2/Select2/Select2V2";
import { Opt } from "../types/PsaProject";
import { usePsaCompanies } from "../api/cascade/usePsaCompanies";

interface Props {
  integrationId: string;
  value: Opt | null;
  onChange: (opt: Opt | null) => void;
  isDisabled?: boolean;
  label?: string;
}

const CompanyTypeahead: React.FC<Props> = ({
  integrationId,
  value,
  onChange,
  isDisabled,
  label,
}) => {
  const [search, setSearch] = useState("");
  const { companies } = usePsaCompanies(integrationId, search);

  return (
    <Select2V2
      label={label ?? ""}
      options={companies}
      value={value}
      onChange={(o: any) => onChange(o ?? null)}
      onInputChange={setSearch}
      isDisabled={isDisabled}
    />
  );
};

export default CompanyTypeahead;
